import React from 'react'
import Featured from './Featured'
import Footer from './Footer'
import Hero from './Hero'
import Navbar from './Navbar'
import Newsletter from './Newsletter'

const Home = () => {
  return (
    <div>
      <Navbar/>
      <Hero/>
      <Featured/>
      <Newsletter/>
      <Footer/>
    </div>
  )
}

export default Home
